import type { PayloadAction, WritableDraft } from '@reduxjs/toolkit'
import type { LocalConfigurationId, TruckConfigurations } from '../configurationSlice'

// the logic here is, that setting any brand sets the configuration to 'fixed' and filter properties filter just for that brand
// if all products have been filtered out, then we may show the remaining products
export const axleBrands = ['continental', 'goodYear', 'bridgestone', 'michelin', 'pirelli', 'fate', 'flexible', 'none'] as const
export type AxleBrand = (typeof axleBrands)[number]

export interface TireDetails {
  preferredBrand?: AxleBrand
  /** Indicates the last interaction with the tire editors version */
  untilVersion?: number
}

export const tireActions = {
  updateLastSeenTireVersion: (state: WritableDraft<TruckConfigurations>, { payload }: PayloadAction<LocalConfigurationId | undefined>) => {
    const configuration = payload && state.configurations[payload]
    if (!configuration) {
      return
    }

    configuration.tires = {
      ...configuration.tires,
      untilVersion: configuration.version,
    }
  },
  setPreferredTireBrand: (
    state: WritableDraft<TruckConfigurations>,
    { payload: { configurationId, preferredBrand } }: PayloadAction<{ configurationId: LocalConfigurationId | undefined; preferredBrand: AxleBrand }>,
  ) => {
    const configuration = configurationId && state.configurations[configurationId]
    if (!configuration) {
      return
    }
    configuration.tires = {
      ...configuration.tires,
      preferredBrand,
      untilVersion: configuration.version,
    }
  },
}
